import { render, staticRenderFns } from "./bannerCell.vue?vue&type=template&id=a38c5424&scoped=true"
import script from "./bannerCell.vue?vue&type=script&lang=js"
export * from "./bannerCell.vue?vue&type=script&lang=js"
import style0 from "./bannerCell.vue?vue&type=style&index=0&id=a38c5424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38c5424",
  null
  
)

export default component.exports